import { render, staticRenderFns } from "./game.vue?vue&type=template&id=262da130"
import script from "./game.vue?vue&type=script&lang=js"
export * from "./game.vue?vue&type=script&lang=js"
import style0 from "~/assets/scss/official.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/scss/skin/skin_deep.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports